import { useEffect, useState } from "react"
import { shallowEqual, useSelector } from "react-redux"
import { useHistory, useLocation } from "react-router-dom"
import { RootState } from "../../../setup"
import { LoaderOverlay } from "../../hooks/loader/LoaderOverlay"
import { SubscriptionModel } from "../../modules/auth/models/SubscriptionModel"
import { UserModel } from "../../modules/auth/models/UserModel"
import { createMastermindCircle, createOpenDiscussion, updateMastermindCircle, updateOpenDiscussion } from "../../services/communityService"
import { CommunityMastermindForm } from "../community/components/CommunityMastermindForm"
import { CommunityOpenDiscussForm } from "../community/components/CommunityOpenDiscussForm"
import { CommunitySelector } from "../community/components/CommunitySelector"
import { CommunityFormEnum } from "../community/enums/CommunityFormEnum"
import { CommunityMastermindCreateModel } from "../community/models/CommunityMastermindCreateModel"
import { CommunityOpenDiscussCreate } from "../community/models/CommunityOpenDiscussCreate"
import { useUserProfileContext } from "../../context/UserProfileContext"
import { hasRole } from "../../utils/permissions"
import { UserRole } from "../../constants/roles"

export const MastermindFormPage = () => {
    const { pathname } = useLocation();
    const isEdit = pathname.includes('/edit/');
    const user = useSelector<RootState>(({auth}) => auth.user, shallowEqual) as UserModel;
    const sub = useSelector<RootState>(({auth}) => auth.subscription, shallowEqual) as SubscriptionModel;
    // Un team member no tiene suscripcion propia (auth.subscription siempre
    // viene vacio para ellos). Lo que importa es la suscripcion del Final User
    // que administra, que ya viaja en 'data' (useUserProfileContext), la misma
    // fuente que usa el backend para validar la creacion del circulo.
    const { data } = useUserProfileContext();
    const isTeamMember = hasRole(user, UserRole.TEAM);
    const history = useHistory();
    const [loading, setLoading] = useState(false);
    const [ type, setType ] = useState<CommunityFormEnum>(CommunityFormEnum.MASTERMIND_CIRCLE);
    

    useEffect(() => {
            document.body.classList.add('my-mastermind-form-wrapper')
            return () => document.body.classList.remove('my-mastermind-form-wrapper')
    }, []);


    const _createMastermindDiscuss = (form: CommunityMastermindCreateModel, id?: string | number) => {
        const _fetch = async () => {
            try {
                setLoading(true);
                const _tags = form.tags.map(t => t.value as string);
                const _invites = form.invites.map(i => i.value.id) as number[];
                if(id)
                    await updateMastermindCircle(id, form.topic, form.content, _tags, _invites, form.facilitator);
                else
                    await createMastermindCircle(form.topic, form.content, _tags, _invites, form.facilitator);
                history.replace(`/community/success?type=${type}`);
            }
            catch {}
            finally {
                setLoading(false);
            }
        }
        _fetch();
    }

    const _createOpenDiscuss = (form: CommunityOpenDiscussCreate, id?: string | number) => {
        const _fetch = async () => {
            try {
                setLoading(true);
                if(id)
                    await updateOpenDiscussion(id.toString(), form.topic, form.description, form.tags.map(t => t.label));
                else 
                    await createOpenDiscussion(form.topic, form.description, form.tags.map(t => t.label));
                history.replace(`/community/success?type=${type}`);
            }
            catch { }
            finally {
                setLoading(false);
            }
        }
        _fetch();
    }

    return (
        <>
            <LoaderOverlay visible={loading} message={'Loading...'} />
            <div className="community-form">
                <div className="w-100 tap-flex-center justify-content-start">
                    <div className="nb-link-underline-500 w-auto cursor-pointer" onClick={()=> history.replace('/my-mastermind-circles')}>
                        Back
                    </div>
                </div>
                <div className="d-flex flex-column" style={{gap: '10px'}}>
                    <h3>
                        Community 
                    </h3>
                    <p>
                        You are among the world’s brightest minds. Here, the space is open for you to share, exchange, and grow—whether in open discussions or exclusive mastermind circles.
                    </p>
                </div>

                <CommunitySelector 
                    onSelect={(id) => setType(id)}
                    selection={type}
                    subs={isTeamMember ? ((data?.subscription as any)?.plan?.title ?? '') : ((sub?.plan as any)?.title ?? '')}
                    isEdited={isEdit}
                />
                {type === CommunityFormEnum.OPEN_DISCUSSION ? (
                    <CommunityOpenDiscussForm onSubmit={_createOpenDiscuss}/>
                ):(
                    <CommunityMastermindForm onSubmit={_createMastermindDiscuss}/>
                )}
            </div>
        </>
    )
}